// extracted by mini-css-extract-plugin
export default {"leave":"_2vcoL","leaveActive":"_2_QNO"};